<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El comercio en la Nueva España</h2>
    <img @click="imageClicked(0)" src="galerias/gameRoom/barco.png" class="mainphoto"/>
    <p class="photo-description">Pabellón flotante. Autor anónimo. Marfil laminado, tallado, calado y policromado. China, siglo XVIII. Contiene 23 personajes de marfil. Colección: Museo “José Luis Bello y González”. Puebla, México.</p>
    <p>Consolidada la conquista de la Nueva España, la Corona Española inició su labor de expansión marítima, encaminada a encontrar una ruta segura hacia el Oriente. La expedición comandada por el español Miguel López de Legazpi y el monje agustino fray Andrés de Urdaneta descrubrió la tan anhelada ruta en 1564, cuando llegaron a las islas San Lázaro, posteriormente llamadas “Filipinas” en honor a Felipe II.</p>
    <p>Provenientes del sur de China, Indochina, Cochinchina y Japón, las mercancías eran llevadas al Parían de los Sangleyes, en Manila, que era el centro del mercado asiático, desde donde eran transportadas al Puerto de Acapulco, en Nueva España. Aunque una buena parte de los productos viajaban hacia Veracruz para su embarque a España, muchos de ellos se comercializaron en la capital del país y, particularmente, en Puebla.</p>
    <p>En el Museo “José Luis Bello y González”, en la ciudad de Puebla, se puede admirar una colección de objetos de marfil, como el Pabellón Flotante, que se muestra en la imagen, considerado un preciado tesoro del patrimonio de México y muestra única de la calidad de los objetos artísticos que llegaban desde Oriente.</p>
  </div>
</template>

<script>
export default {
  name: "GameM1",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
